import { HALResponse } from "../shared/model/app.model";
import { Reminder, ReminderResponse, ReminderStatus, ReminderViewModel } from "./reminder.model";
import { HttpClient } from "@angular/common/http";
import { map, shareReplay } from "rxjs/operators";
import { Observable } from "rxjs";
import { LogService } from "../logs/log.service";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class ReminderService {
	
	static getStatusTooltipText(reminder: Reminder): string
	{
		let retval = reminder.status.description;
		if( reminder.late && reminder.status.name == 'P')
			retval += ', should have started already';
		else if( reminder.late && reminder.status.name == 'A')
			retval += ', should have ended already'
		else if( reminder.soon && reminder.status.name == 'P')
			retval += ', should start soon';
		else if( reminder.soon && reminder.status.name == 'P')
			retval += ', should end soon';
		
		return retval;
	}
	
	static getReminderIconClass(reminder: Reminder, label = true): string
	{
		let retval = 'glyphicon reminder-status label ';
		if( reminder.late )
			retval += 'glyphicon-bell label-danger reminder-late';
		else if( reminder.soon )
			retval += 'glyphicon-bell label-warning reminder-soon';
		else if( reminder.status.name == 'P' )
			retval += 'glyphicon-bell label-success';
		else if( reminder.status.name == 'A' )
			retval += 'glyphicon-time label-primary';
		else if( reminder.status.name == 'E' || reminder.status.name == 'K')
			retval += 'glyphicon-ok label-info';
		else if( reminder.status.name == 'C' )
			retval += 'glyphicon-remove label-default';
		else if( reminder.status.name == 'D' )
			retval += 'glyphicon-remove label-default'
		return retval;
	}
	
	static mapToViewModel(reminders: Reminder[]): ReminderViewModel[]
	{
		return reminders.map(r => {
			return {
				...r,
				iconClass: ReminderService.getReminderIconClass(r),
				tooltip: ReminderService.getStatusTooltipText(r)
			}
		})
	}
	
	constructor(
		private http: HttpClient
	) { }
	
	private statuses?: Observable<ReminderStatus[]>
	
	getStatuses(): Observable<ReminderStatus[]> {
		return (this.statuses)
			? this.statuses
			: this.statuses = this.http.get<HALResponse<{ reminderStatuses: ReminderStatus[]}>>('/api/reminderStatuses')
			.pipe(
				map(res => res._embedded.reminderStatuses),
				shareReplay(1)
			)
	}
	
	getReminders(params: Reminder.Query): Observable<ReminderResponse> {
		return this.http.get<HALResponse<{ reminders: Reminder[] }>>('/api/reminders', { params: params })
			.pipe(
				map(r => {
					const data: ReminderResponse = r._embedded.reminders as ReminderResponse;
					data.page = r.page;
					return data
				})
			)
	}
	
	fetchRemindersOnTicker(count = 1000): Observable<Reminder[]> {
		return this.getReminders({
			onTicker: true,
			log: LogService.selectedLog?.id,
			size: count
		})
	}
	
	updateStatus(reminder: Reminder, toStatus: ReminderStatus): Observable<Reminder.Model> {
		let update = { status: toStatus._links.self.href } as Reminder.Model
		return this.http.patch<Reminder.Model>(reminder._links.self.href, update)
	}
}